import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import BillImage from '../Assets/Bill.jpg';
import sign from '../Assets/sign.png';
// import qrcode from '../Assets/qrcode.png';

const EstimateInvoice = () => {
  const [orderData, setOrderData] = useState(null);
  const { order_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [totalAmount, setTotalAmount] = useState(0);
  const [discount_percentage, setdiscount_percentage] = useState(0);
  const [packing_percentage, setpacking_percentage] = useState(0);
  const [commission_percentage, setcommission_percentage] = useState(0);
  const [discount_amt, setdiscount_amt] = useState(0);
  const [commission_amount, setcommission_amt] = useState(0);
  const [packing_amount, setpacking_amt] = useState(0);
  const [grandtotal, setGrandTotal] = useState(0);
  const [taxSummary, setTaxSummary] = useState({
    cgst: 0,
    sgst: 0,
    // packing_charge: 0,
    totalTax: 0,

  });


  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}print_estimate_detail.php`, { order_id });

        if (response.data.head?.code === 200) {
          const data = response.data.body;
          setOrderData(data);

          const subtotal = parseFloat(data.final_billing?.[0]?.subtotal || 0);
          const cgst = parseFloat(data.final_billing?.[0]?.cgst || 0);
          const sgst = parseFloat(data.final_billing?.[0]?.sgst || 0);
          const discount_percentage = parseFloat(data.final_billing?.[0]?.discount_percentage || 0);

          const discount_amt = parseFloat(data.final_billing?.[0]?.discount_amt || 0);

          const commission_percentage = parseFloat(data.final_billing?.[0]?.commission_percentage || 0);

          const commission_amount = parseFloat(data.final_billing?.[0]?.commission_amt || 0);
          const packing_percentage = parseFloat(data.final_billing?.[0]?.packing_percentage || 0);

          const packing_amount = parseFloat(data.final_billing?.[0]?.packing_amt || 0);

          // const packing = parseFloat(data.final_billing?.[0]?.packing_charge || 0);
          const gst_total = parseFloat(data.final_billing?.[0]?.gst_total || 0);
          const total = parseFloat(data.final_billing?.[0]?.total || 0);
          setTotalAmount(subtotal); // You may want to include packing here if needed
          setdiscount_percentage(discount_percentage);
          setdiscount_amt(discount_amt);
          setcommission_percentage(commission_percentage);
          setcommission_amt(commission_amount);
          setpacking_percentage(packing_percentage);
          setpacking_amt(packing_amount);
          setGrandTotal(total);
          setTaxSummary({
            cgst,
            sgst,
            discount_percentage,
            discount_amt,
            commission_percentage,
            commission_amount,
            packing_percentage,
            packing_amount,
            // packing_charge: packing,
            totalTax: gst_total,
          });
        } else {
          console.error("Failed to fetch order details");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    };

    fetchOrderDetails();
  }, []);



  // const bill_detail = orderData?.bill_detail || [];
  // const final_billing = orderData?.final_billing || [];


  // // Calculate bottom section totals
  // let totalAmount = 0;

  // bill_detail.forEach((item) => {
  //   totalAmount += parseFloat(item.total_per_product) || 0;

  // });

  // let taxSummary = {};

  // // final_billing.forEach((item) => {
  // //   Object.keys(item).forEach((taxKey) => {
  // //     if (item[taxKey] && typeof item[taxKey] === "object") {
  // //       const gstRate = parseInt(taxKey.replace("tax", ""), 10); // Extract tax percentage (e.g., 12 from "tax12")

  // //       if (!taxSummary[gstRate]) {
  // //         taxSummary[gstRate] = {
  // //           taxableValue: "",
  // //           cgst: 0,
  // //           sgst: 0,
  // //           totalTax: "",
  // //         };
  // //       }

  // //       taxSummary[gstRate].taxableValue += item[taxKey].without_gst || 0;
  // //       taxSummary[gstRate].cgst += (item[taxKey].gst_amt || 0) / 2;
  // //       taxSummary[gstRate].sgst += (item[taxKey].gst_amt || 0) / 2;
  // //       taxSummary[gstRate].totalTax += item[taxKey].gst_amt || 0;
  // //     }
  // //   });
  // // });

  const numberToWords = (num) => {
    if (num === 0) return "Zero";

    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
      return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " and " + convertBelowThousand(n % 100) : "");
    };

    let integerPart = Math.floor(num); // Rupees
    let decimalPart = Math.round((num - integerPart) * 100); // Paise

    let result = "";

    // Convert Rupees
    if (integerPart > 0) {
      let crores = Math.floor(integerPart / 10000000);
      let lakhs = Math.floor((integerPart % 10000000) / 100000);
      let thousands = Math.floor((integerPart % 100000) / 1000);
      let hundreds = integerPart % 1000;

      if (crores) result += convertBelowThousand(crores) + " Crore ";
      if (lakhs) result += convertBelowThousand(lakhs) + " Lakh ";
      if (thousands) result += convertBelowThousand(thousands) + " Thousand ";
      if (hundreds) result += convertBelowThousand(hundreds);
    } else {
      result = "Zero";
    }

    result = result.trim();

    // Convert Paise if present
    if (decimalPart > 0) {
      result += ` and ${convertBelowThousand(decimalPart)} Paise`;
    }

    return result + " Only";
  };


  useEffect(() => {
    const waitForContentAndPrint = () => {
      const contentReady = document.readyState === 'complete';
      const hasContent = document.body && document.body.innerText.trim().length > 0;

      if (contentReady && hasContent) {
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler('onPrintRequest');
        } else {
          window.print();
        }
      } else {
        setTimeout(waitForContentAndPrint, 200); // Retry after delay
      }
    };

    // const timer = setTimeout(waitForContentAndPrint, 2000);
    if (!orderData || !orderData.buyer_detail) return; // 🛡️ Wait until data is ready

    const originalTitle = document.title; // Save the original site title

    const timer = setTimeout(() => {
      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;


      document.title = `quotation_${orderData.buyer_detail.name}_${formattedDate}`; // Set dynamic invoice title
      window.print();

      // After print dialog opens, restore the original title
      setTimeout(() => {
        document.title = originalTitle;
      }, 1000); // Small delay
    }, 2000); // 2-second delay

    // return () => clearTimeout(timer);
    return () => {
      clearTimeout(timer);
      document.title = originalTitle; // Always reset title if component unmounts
    };
  }, [orderData]);









  if (!orderData || !orderData.final_billing) return null;

  return (
    <>
      <div className="invoice-container"

        style={{
          width: "100%",
          maxWidth: "100%",
          margin: "auto",
          padding: "10px",
          fontFamily: "Arial, sans-serif",
          borderRight: "2px solid black",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover", // or "contain"
          backgroundPosition: "center",
          minHeight: "1000px", // ensure there's enough height to see it
        }}
      >

        {/* <h3 style={{ textAlign: "center" }}>Estimate</h3> */}
        <div style={{ textAlign: "center", fontSize: "20px", color: "black" }}>
          {/* GSTIN No: {orderData.final_billing?.[0]?.gst_no} Tax Invoice */}
          {orderData && orderData.seller_detail && (
            <>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "20px",
                color: "black",

              }}>

                <div style={{ flex: 1, textAlign: "left", fontSize: "12px", color: "#000" }}>
                  GSTIN No: {orderData.seller_detail.gst_no}
                </div>
                <div style={{ flex: 1, textAlign: "center", color: "#000" }}>
                  Quotation
                </div>
                <div style={{ flex: 1, textAlign: "right", fontSize: "12px" }}>
                  {/* (ORIGINAL FOR RECIPIENT)*/}
                </div>

              </div>
              {/* <br /> */}
              <p style={{ color: "#000", fontSize: "30px", margin: "-10px" }}>{orderData.seller_detail.shop_name}</p>
              <p style={{ color: "#000", fontSize: "12px", margin: "0px" }}>[ ஸ்ரீதரன் கூலர்ஸ் ]</p>
              <span style={{ fontSize: "14px", color: "#000" }}>{orderData.seller_detail.address},{orderData.seller_detail.city},{orderData.seller_detail.state},<br />Email ID : {orderData.seller_detail.email},Mobile : {orderData.seller_detail.phone}.</span>


              {/* <br />
        <span style={{ fontSize: "14px", }}>{orderData.final_billing?.[0]?.city}, {orderData.final_billing?.[0]?.pincode},</span>
        <br />
        <span style={{ fontSize: "14px", }}>{orderData.final_billing?.[0]?.state}</span> */}
              {/* <br /> */}
              {/* <span style={{ fontSize: "14px", }}>GSTIN No: {orderData.final_billing?.[0]?.gst_no}</ span> */}
            </>)}
        </div>

        <div style={{ display: "flex", fontSize: "11px", justifyContent: "space-between", borderTop: "1px solid black", borderBottom: "1px solid black", paddingBottom: "10px", paddingTop: "10px" }}>
          <div style={{ color: "#000" }}>
            {/* {orderData && orderData.seller_detail && (
            <>
              <strong>{orderData.seller_detail.shop_name}</strong>,
              <br />
              <strong>{orderData.seller_detail.gst_no}</strong>,
              <br />
              <strong>{orderData.seller_detail.phone}</strong>,
              <br />
              {orderData.seller_detail.address}
              <br />
              {orderData.seller_detail.city}
            </>
          )} */}
            <strong style={{ color: "#000" }}>Quotation No:</strong> {orderData.order_id}
          </div>

          {orderData ? (
            <div style={{ color: "#000" }}>

              <strong style={{ color: "#000" }}>Date:</strong> {orderData.order_date}
            </div>
          ) : (
            <p> </p>
          )}

        </div>
        <div style={{ marginTop: "10px", color: "#000", borderBottom: "1px solid black", paddingBottom: "10px", fontSize: "11px" }} className="d-flex justify-content-between">
          <div >
            {orderData && orderData.buyer_detail && (
              <>
                <strong style={{ color: "#000" }}>Buyer (Bill to) : </strong><br />
                <strong style={{ color: "#000" }}> {orderData.buyer_detail.name},</strong> <br />
                {orderData.buyer_detail.tax_number && (
                  <>
                    {orderData.buyer_detail.tax_number},
                    <br />
                  </>
                )}
                {orderData.buyer_detail.address},
                {orderData.buyer_detail.state},
                {orderData.buyer_detail.telephone}
              </>
            )}
          </div>
          <div>
            {/*
          {orderData && orderData.seller_detail && (
            <>
              <strong style={{ color: "#000" }}>Bank Details : </strong><br />
              <strong style={{ color: "#000" }}>Bank Name : {orderData.seller_detail.bank_name},</strong> <br />
              A/C Holder Name : {orderData.seller_detail.acc_holder_name},< br />
              A/C Number : {orderData.seller_detail.acc_no},< br />
              IFSC : {orderData.seller_detail.ifsc_code},
              MICR : {orderData.seller_detail.micr_code}
            </>
          )}
            */}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", minHeight: "68vh" }}>
          <div style={{ flex: 1, overflow: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Sno</th>

                  <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Product Name</th>
                  {/* <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>HSN Code</th> */}
                  <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>Rate</th>
                  <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>Quantity</th>
                  {/* <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>Price/Case</th> */}

                  <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "right" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {orderData?.bill_detail?.length > 0 ? (
                  orderData.bill_detail.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>{index + 1}</td>

                      <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                        {item.product_name}
                      </td>
                      {/* <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>{item.hsn_code}</td> */}
                      <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>
                        {Number(item.amount_per_product || 0).toFixed(2)}
                      </td>
                      <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>
                        {item.qty} {item.unit}
                      </td>
                      {/* <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "center" }}>
                      {Number(item.amount_per_product || 0).toFixed(2)}
                    </td> */}

                      <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "right" }}>
                        {Number(item.total_per_product || 0).toFixed(2)}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", padding: "10px" }}>Loading...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div
            style={{
              height: "100px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginTop: "5px",
              marginBottom: "5px",
              borderTop: "1px solid black", paddingTop: "5px"
            }}
          >

            {/* Left: QR code with caption */}
            <div style={{ textAlign: "left", fontSize: "11px" }}>
              {/* <img width="90px" src={qrcode} alt="QR Code" /> */}
              {/* <div style={{ maxWidth: "200px" }}>
              <strong>Scan QR</strong> to view photos, videos, price list
            </div> */}
            </div>

            {/* Right: Totals */}
            <div style={{ textAlign: "right", flex: 1 }}>
              {/* Sub Total */}
              {(Number(taxSummary?.cgst || 0) > 0 ||
                Number(taxSummary?.commission_percentage || 0) > 0 ||
                Number(taxSummary?.discount_percentage || 0) > 0 ||
                Number(taxSummary?.packing_percentage || 0) > 0) && (
                  <div style={{ fontSize: "11px", marginBottom: "5px", color: "#000" }}>
                    <strong>Sub Total : ₹ {Math.round(totalAmount).toFixed(2)}</strong>
                  </div>
                )}

              {/* Discount */}
              {/* {taxSummary.discount_percentage > 0 && (
              <div style={{ fontSize: "10px", marginBottom: "5px", color: "#000" }}>
                <strong>
                  Discount ({taxSummary.discount_percentage}%)(-) : ₹{" "}
                  {taxSummary.discount_amt.toFixed(2)}
                </strong>
              </div>
            )} */}

              {/* Commission */}
              {/* {taxSummary.commission_percentage > 0 && (
              <div style={{ fontSize: "10px", marginBottom: "5px", color: "#000" }}>
                <strong>
                  Commission ({taxSummary.commission_percentage}%)(-) : ₹{" "}
                  {taxSummary.commission_amount.toFixed(2)}
                </strong>
              </div>
            )} */}

              {/* Packing */}
              {/* {taxSummary.packing_percentage > 0 && (
              <div style={{ fontSize: "10px", marginBottom: "5px", color: "#000" }}>
                <strong>
                  Packing ({taxSummary.packing_percentage}%)(+) : ₹{" "}
                  {taxSummary.packing_amount.toFixed(2)}
                </strong>
              </div>
            )} */}

              {/* GST/IGST */}
              {orderData?.buyer_detail?.state?.trim().toLowerCase() === "tamilnadu" ? (
                <>
                  {taxSummary.cgst > 0 && (
                    <div style={{ fontSize: "11px", marginBottom: "5px", color: "#000" }}>
                      <strong>CGST (9%)(+) : ₹ {taxSummary.cgst.toFixed(2)}</strong>
                    </div>
                  )}
                  {taxSummary.sgst > 0 && (
                    <div style={{ fontSize: "11px", marginBottom: "5px", color: "#000" }}>
                      <strong>SGST (9%)(+) : ₹ {taxSummary.sgst.toFixed(2)}</strong>
                    </div>
                  )}
                </>
              ) : (
                taxSummary.sgst > 0 && (
                  <div style={{ fontSize: "11px", marginBottom: "5px", color: "#000" }}>
                    <strong>IGST (18%)(+) : ₹ {taxSummary.totalTax.toFixed(2)}</strong>
                  </div>
                )
              )}

              {/* Grand Total */}
              <div style={{ fontSize: "24px", marginTop: "10px", color: "#000" }}>
                <b>Grand Total : ₹ {grandtotal.toFixed(2)}</b>
              </div>
            </div>
          </div>

          {/* </ div> */}

          <div style={{ borderTop: "1px solid black", marginTop: "5px", paddingTop: "5px", color: "#000" }}>
            <strong>Amount Chargeable (in words):</strong>{" "}
            {numberToWords(
              Math.round(
                grandtotal
              )
            ).toUpperCase()}
          </div>

          {/*
        {orderData?.buyer_detail?.state?.trim().toLowerCase() === "tamilnadu" ? (
          <div style={{color:"#000", borderTop: "1px solid black", borderBottom: "1px solid black", margin: "10px 0px", padding: "10px 0px" }}>
            <strong>Tax Details:</strong>
            <table style={{color:"#000", width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>Taxable Value</th>

                  <th style={{color:"#000", border: "1px solid black", padding: "5px" }}>CGST(%)</th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>CGST</th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px" }}>SGST(%)</th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>SGST</th>

                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>Total Tax</th>
                </tr>
              </thead>
              <tbody>
                {orderData?.final_billing?.length > 0 && (
                  <tr>
                    <td style={{ color:"#000",border: "1px solid black", padding: "5px", textAlign: "right" }}>
                      {parseFloat(orderData?.final_billing?.[0]?.subtotal || 0).toFixed(2)}
                    </td>
                    <td style={{color:"#000", border: "1px solid black", padding: "5px" }}>
                      {orderData?.final_billing?.[0]?.cgst_percentage || 0}%
                    </td>
                    <td style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                      {parseFloat(orderData?.final_billing?.[0]?.cgst || 0).toFixed(2)}
                    </td>
                    <td style={{color:"#000", border: "1px solid black", padding: "5px" }}>
                      {orderData?.final_billing?.[0]?.sgst_percentage || 0}%
                    </td>
                    <td style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                      {parseFloat(orderData?.final_billing?.[0]?.sgst || 0).toFixed(2)}
                    </td>
                    <td style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                      {parseFloat(orderData?.final_billing?.[0]?.gst_total || 0).toFixed(2)}
                    </td>
                  </tr>
                )}

                
                <tr>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                    Total :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {(totalAmount).toFixed(2)}
                  </th>
                  <th style={{ color:"#000",border: "1px solid black", padding: "5px" }}>-</th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                    {taxSummary.cgst?.toFixed(2) || "0.00"}
                  </th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px" }}>-</th>
                  <th style={{color:"#000", border: "1px solid black", padding: "5px", textAlign: "right" }}>
                    {taxSummary.sgst?.toFixed(2) || "0.00"}
                  </th>
                  <th style={{ color:"#000",border: "1px solid black", padding: "5px", textAlign: "right" }}>
                    {taxSummary.totalTax?.toFixed(2) || "0.00"}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <p></p>
        )}
        */}
          <div style={{ textAlign: "left", color: "#000" }}>
            <strong style={{ borderBottom: "1px solid", color: "#000" }}>Declaration</strong><br />
            <p><b>We declare that this quotation shows the actual price of the goods described and that all particulars are true and correct.</b> </p>
          </div>
          <div className="d-flex align-items-top justify-content-between">
            <div style={{ textAlign: "left", width: "60%", color: "#000" }}>
              <p style={{ color: "#000", fontSize: "12px" }}><b>Terms & Conditions:</b>< br />1.All Disputes Subject to Madurai Jurisdiction< br />2.Goods once sold cannot be taken back< br />3.Interest eill be charge @30% if bill is not paid within 30 days</p>
            </div>
            {/* <div>
        <img width="100px" src={qrcode}/>
      </div> */}
            <div style={{ textAlign: "right", color: "#000" }}>
              <strong style={{ color: "#000", fontSize: "12px" }} >For {orderData.seller_detail.shop_name}</strong>
              <br />
              <img src={sign} width={"200px"} />
              <br /><br />
              <strong style={{ color: "#000", fontSize: "12px" }} >Authorized Signatory</strong>
            </div>
          </div>
          <br />
          {/* <img src={FooterImage} style={{ width: "100%", }} alt="Print" /> */}
          {/* <div style={{height:"150px"}}></div> */}
        </div>
        <hr style={{ margin: "0px", color: "#000" }} />
        <p style={{
          //       position: "fixed",
          // bottom: "0",
          width: "100%",
          textAlign: "center",
          // borderTop: "1px solid #000",
          color: "#000",
        }}>This is a Computer Generated Quotation</p>
      </div>

    </>
  );
};

export default EstimateInvoice; 